import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IWorkType } from './interfaces';

export const getWorkTypeList = (data: IDynamicTableParams) => {
  return instance()
    .post<IWorkType[]>('/dictionary/workTypes/listMap', data)
    .then((response) => response.data);
};

export const getWorkTypeAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/dictionary/workTypes/availableColumns')
    .then((response) => response.data);
};

export const getWorkTypeAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/dictionary/workTypes/availableGroupColumns')
    .then((response) => response.data);
};

export const loadWorkType = (workTypeId: number) => {
  return instance()
    .post<IWorkType>('/dictionary/workTypes/load', { workTypeId })
    .then((response) => response.data);
};

export const createWorkType = (workType: IWorkType) => {
  return instance()
    .post<IWorkType>('/dictionary/workTypes/create', workType)
    .then((response) => response.data);
};

export const updateWorkType = (workType: IWorkType) => {
  return instance()
    .post<IWorkType>('/dictionary/workTypes/update', workType)
    .then((response) => response.data);
};

export const deleteWorkType = (workTypeId: number) => {
  return instance()
    .post('/dictionary/workTypes/archive', { workTypeId })
    .then((response) => response.data);
};

export const recoverWorkType = (workTypeId: number) => {
  return instance()
    .post('/dictionary/workTypes/recover', { workTypeId })
    .then((response) => response.data);
};
